import{jsx as a}from"react/jsx-runtime";import s from"./atlassian/AtlassianUpload.js";const t={atlassian:s},r=({provider:s})=>a(t[s],{});export{r as default};
